export default __webpack_public_path__ + "static/media/MANZOOR.2d74dcb6.JPG";